import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';
import moment from 'moment';

import xeRebook from 'actions/booking/xeRebook.action';
import { beChargeCardOnFileV1 } from 'actions/payment/beChargeCardOnFile.action';
import { deleteAllAppointmentsV1 } from 'actions/scheduler/deleteAllAppointments.action';
import fetchEventsBySalon from 'actions/scheduler/fetchEventsBySalon.action';
import fetchProceduresBySalon from 'actions/scheduler/fetchProceduresBySalon.action';
import undoProcedure from 'actions/scheduler/undoProcedure.action';
import updateProcedure from 'actions/scheduler/updateProcedure';
import { feProcedureModalMount } from 'actions/ui.actions';
import confirmed from 'assets/images/Confirm_procedure.svg';
import delIco from 'assets/images/Delete_procedure.svg';
import calIcon from 'assets/images/ico-calendar.svg';
import rebookingIcon from 'assets/images/rebook.png';
import smsIco from 'assets/images/Send_text.svg';
import unconfirmed from 'assets/images/Unconfirm_procedure.svg';
import wifiIcon from 'assets/images/wifi.png';
import SalonFlag from 'components/core/SalonFlag.component';
import ToggleFeature from 'components/core/ToggleFeature.component';
import DialogMessage from 'components/dialog/DialogMessage.component';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import HeartIcon from 'components/generic/HeartIcon.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import Space from 'components/generic/Space.component';
import CurrencySign from 'components/price/CurrencySign.component';
import LINK from 'constants/link.const';
import EMSG from 'constants/messages/errorMessage.const';
import { AP_STATUS } from 'constants/payment/appointmentStatus.const';
import CHARGE_TO_DEPOSIT from 'constants/payment/chargeToDeposit.const';
import DEPOSIT_ACTION from 'constants/payment/depositAction.const';
import SF from 'constants/salonFlag.const';
import S from 'constants/string.const';
import { selectCurrentSalonBetaAnnualSalon, selectCurrentSalonBilling } from 'selectors/currentSalon.selectors';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';
import { selectHideDetails } from 'selectors/user';
import getAny from 'utils/accessors/getAny.util';
import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromStringToXs from 'utils/converters/fromStringToXs';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import { formatSegmentDay, formatSegmentWeek } from 'utils/date/format.util';
import call from 'utils/functions/call.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import linkTo from 'utils/links/linkTo.util';
import navFor from 'utils/links/navFor.util';
import logger from 'utils/logger.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';
import isTruthy from 'utils/predicates/isTruthy.util';
import { deepFreeze } from 'utils/values/constant.util';
import parsfixed from 'utils/values/parsfixed.util';

import { clearChargeError, getPreferenceList } from 'booking/actions';
import AlertDialog from 'checkout/components/AlertDialog';
import { purchaseSmsBundle } from 'clientCommunications/actions';
import ShowTags from 'clientProfile/components/BasicProfile/ShowTags';
import {
  clearNoshowChargeInfo,
  clearRequestDepositSuccess,
  createIfAllowed,
  deletePreference,
  emptyAppointmentStatuses,
  fetchAppointmentDetails,
  fetchClientLabels,
  fetchDeposit,
  hideInactiveStylists,
  markAppointmentEdit,
  pickCurrentStylist,
  reorderStylists,
  reorderStylistsThenSave,
  requestDeposit,
  revertProcedureLog,
  savePreference,
  saveStylistOrder,
  setBookedByButton,
  setCreation,
  setCurrentDay,
  setDragFrom,
  setDropTime,
  setModal,
  setView,
  showAllStylist,
  updateNewBookingDate,
} from 'scheduler/actions';
import CardModalContent from 'scheduler/components/Card/ModalContent';
import CardModalFooter from 'scheduler/components/Card/ModalFooter';
import CardModalHeader from 'scheduler/components/Card/ModalHeader';
import ChargeFeeForm from 'scheduler/components/ChargeFeeForm';
import NoSmsCredit from 'scheduler/components/common/NoSmsCredit';
import RebookAppointment from 'scheduler/components/common/RebookAppointment';
import { REBOOK_TIME } from 'scheduler/components/common/RebookAppointmentDialog.component';
import RevertButton from 'scheduler/components/common/RevertButton';
import SmsButtonNew from 'scheduler/components/common/SmsButtonNew';
import ConfirmationDialog from 'scheduler/components/ConfirmationDialog';
import DepositBankedNoShowModal from 'scheduler/components/DepositBankedNoShowModal';
import DepositRequesModal from 'scheduler/components/DepositRequesModal';
import PreferencesTooltip from 'scheduler/components/Text/PreferencesTooltip.component';
import SmsStoppedTextComponent from 'scheduler/components/Text/SmsStoppedText.component';
import { fetchClientDepositDetails } from 'settings/balance-sheet/actions';
import { getSalonOnlineSettings } from 'settings/online-booking/actions';
import NoBillingModal from 'settings/online-booking/modals/NoBillingModal';
import { trackEvent } from 'tracking/actions';

import CN from './ProcedureModal.module.scss';

const L = logger('ProcedureModal');

const fromPropsToProcedures = (options) => {
  const appointmentId = options?.procedure?.appointment?.id ?? void 1;
  return options?.appointmentDetails?.[appointmentId]?.response?.procedures ?? void 1;
};

const STATUS_BOOKING = Object.freeze({
  salon_created: 'Booked in salon',
  online_rebooking: 'Rebooked online',
  online_booking: 'Booked online',
  quick_setup: 'Quick set up',
  patch_test: 'Booked online',
});

const STATUS_BOOKING_IMG = Object.freeze({
  online_rebooking: rebookingIcon,
  online_booking: wifiIcon,
});

const DeleteAppointmentButton = ({ onClick }) => (
  <button onClick={onClick} className="btn-delete-booking">
    <img src={delIco} alt="Delete booking" />
    <span>Delete</span>
  </button>
);

class ProcedureModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownModal: false,
      revertModal: false,
      expanded: false,
      footerButtons: true,
      modalCancel: false,
      modalCheckout: false,
      modalIsOpen: false,
      modalDeleteCurrentBooking: false,
      btnClassActive: false,
      noShowModal: false,
      chargeFeeModal: false,
      confirmChargeFail: false,
      bankSuccessModal: false,
      deleteBooking: false,
      loadPreference: false,
      modalRequestDeposit: false,
      modalRequestSend: false,
      modalSetupPaymentAccount: false,
      showSms: false,
      showRebookComponent: false,
      oldAppointment: null,
      isCancelling: false,
      modalNoSmsCredit: false,
      modalClientNoPhone: false,
      smsStoppedModal: false,
      errorMessage: '',
      isBillingRendered: false,
    };
  }

  UNSAFE_componentWillMount() {
    const {
      setCreation,
      ncobTinyUrl,
      procedure,
      fetchAppointmentDetails,
      fetchClientDepositDetails,
      setModal,
      salonId,
      getSalonOnlineSettings,
    } = this.props;

    const appointmentId = procedure?.appointment?.id;

    if (appointmentId) {
      const clientId = procedure?.appointment?.client?.id || 0;

      fetchAppointmentDetails(appointmentId, salonId);
      fetchClientDepositDetails(salonId, clientId, appointmentId);
      setModal(false);
      setCreation(false);
    }

    if (!ncobTinyUrl) getSalonOnlineSettings(salonId);
  }

  componentDidMount() {
    const el = document.querySelector('.card-modal-wraper');

    if (el) {
      el.style.position = 'fixed';
      el.style.left = 'auto';
      el.style.right = 'auto';
      el.style.top = '19%';
      el.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'center' });
    }
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProp) {
    if (nextProp.preferenceList?.length === 0 && !this.state.loadPreference) {
      this.loadPreference();
      this.setState({ loadPreference: true });
    }
  }

  componentDidUpdate() {
    const innerWidth = window.innerWidth;
    const animatedZoomedInCard = document.querySelector('.card-modal-wraper.animated.zoomIn');
    const isOneStylist = document.querySelector('.one-stylist');
    const isTwoStylists = document.querySelector('.two-stylist');
    const isMoreThanTwo = document.querySelector('.three-and-more-stylists');

    if (animatedZoomedInCard) {
      const bounding = animatedZoomedInCard.getBoundingClientRect();
      const cardStyle = animatedZoomedInCard.style;

      if (bounding.left < 120) {
        if (isMoreThanTwo) cardStyle.left = '60px';
        if (isMoreThanTwo) cardStyle.right = 'auto';
        if (isOneStylist) cardStyle.left = '39%';
        if (isTwoStylists) cardStyle.left = '12%';
      }

      if (innerWidth && bounding.right + 100 > innerWidth) {
        if (isMoreThanTwo) cardStyle.left = 'auto';
        cardStyle.right = isTwoStylists ? '47%' : '149px';
      }
    }
  }

  componentWillUnmount() {
    this.props.setModal(true);
    this.props.setCreation(true);
    this.props.clearChargeError();
  }

  onViewClientProfile = () => {
    this.props.trackEvent('modal_view_profile');

    const clientId = this.props?.procedure?.appointment?.client?.id;

    if (!clientId) return;

    const bgn = this.props?.procedure?.start_time;
    const salonId = this.props?.salonId;
    const stylistId = this.props?.procedure?.stylist?.id;
    const dayView = this.props?.dayView;

    const path =
      !dayView && this.props.history.location.pathname.includes('/week/')
        ? `/salon/${salonId}/week/${formatSegmentWeek(bgn)}/${stylistId}/client/${clientId}`
        : `/salon/${salonId}/day/${formatSegmentDay(bgn)}/client/${clientId}`;

    this.props.history.push(path);
    this.props.closeModal();
  };

  onEditBooking = (ev) => {
    if (this.checkIsLoading()) return;

    const { procedure, isReBooking, closeModal, salonId, dayView } = this.props;

    navFor('ProcedureModal.onEditBooking()', this.props).push({
      pathname: linkTo({
        pattern: dayView ? LINK.bookingDayLoad : LINK.bookingWeekLoad,
        params: {
          salonId,
          appointmentId: procedure?.appointment?.id,
          dateString: dayView ? formatSegmentDay(procedure?.start_time) : formatSegmentWeek(procedure?.start_time),
          stylistId: procedure?.stylist?.id,
        },
      }),
      state: { openCalendar: fromAnyToBool(isReBooking || ev?.reschedule) },
    });

    closeModal();
  };

  onDelete = (depositData, clientHasCard, fromDeleteButton) => {
    L.info('onDelete()', { depositData, clientHasCard, fromDeleteButton });

    const { procedure, updateProcedureStatus, status } = this.props;

    const procedures = fromPropsToProcedures(this.props);
    const cancelStatus = fromDeleteButton ? 'deleted' : 'canceled';
    const depositAmount = depositData?.amount;
    const depositSource = depositData?.source;
    const procedureDeposit = procedure?.appointment?.deposit;

    if (status === 'no_show' || status === 'canceled') {
      updateProcedureStatus(procedures, cancelStatus);
      this.setState({ modalIsOpen: false });
    } else if (status === 'no_show' || status === 'paid') {
      updateProcedureStatus(procedures, cancelStatus);
      this.setState({ modalIsOpen: false });
    } else if (depositData && !clientHasCard) {
      if (depositAmount <= 0 || depositSource === 'online') {
        updateProcedureStatus(procedures, cancelStatus);
        this.setState({ modalIsOpen: false });
      } else if (depositAmount > 0 && depositSource !== 'online' && !fromDeleteButton) {
        this.setState({ chargeFeeModal: true, deleteBooking: fromDeleteButton });
      } else if (depositAmount > 0 && depositSource !== 'online' && fromDeleteButton) {
        // has deposit no card, click delete not cancel
        this.setState({ chargeFeeModal: true, deleteBooking: fromDeleteButton });
      }
    } else if (!depositData && !clientHasCard) {
      updateProcedureStatus(procedures, cancelStatus);
      this.setState({ modalIsOpen: false });
    } else if (procedureDeposit !== 'refunded' && !fromDeleteButton) {
      this.setState({ chargeFeeModal: true, deleteBooking: fromDeleteButton });
    } else if (clientHasCard && fromDeleteButton) {
      this.setState({ chargeFeeModal: true, deleteBooking: true });
    }

    if (procedureDeposit === 'refunded') {
      this.onStatusChange(cancelStatus);
    }
  };

  onDeleteAll = (fromDeleteButton) => {
    L.info('onDeleteAll()', 'fromDeleteButton:', fromDeleteButton);

    this.props.updateProcedureStatus(fromPropsToProcedures(this.props), 'deleteAll');
    this.setState({ modalIsOpen: false });
  };

  onDeleteAllClicked = () => void this.setState({ modalIsOpen: true });
  onDeleteCurrent = () => void this.setState({ modalDeleteCurrentBooking: true });

  onStatusChange = (status, action = '', amount = 0, depositData = {}) => {
    this.props.handleStatusChange(status, action, amount, depositData, this.state.isCancelling);
    this.props.trackEvent(`modal_${action}`);
  };

  onPreferredClick = (serviceId) => {
    if (this.props.procedure.appointment.client && this.props.procedure.appointment.client.id) {
      const clientId = this.props.procedure.appointment.client.id;
      const findPreference = this.props.preferenceList.filter((c) => c.service === serviceId);
      if (findPreference.length > 0) {
        this.props.deletePreference(this.props.salonId, clientId, findPreference[0].id);
      } else {
        const stylistId = this.props.procedure.stylist.id;
        this.props.savePreference(this.props.salonId, clientId, stylistId, serviceId);
      }
    }
  };

  // cancellation
  onCancelClick = () => void this.setState({ modalCancel: true });
  onConfirmCancel = (depositData, clientHasCard) => {
    this.onDelete(depositData, clientHasCard, false);
    this.setState({ footerButtons: false, modalCancel: false, isCancelling: true });
  };

  // checkout
  onCheckoutClick = () => void this.setState({ modalCheckout: true });
  onCheckoutWalking = () => {
    if (!this.checkIsLoading()) {
      this.props.onCheckout(this.props.appointmentDetails[this.props.procedure.appointment.id].response);
    }
  };
  onCheckoutFromModal = () => {
    if (this.checkIsLoading()) {
      return;
    }
    this.props.onCheckout(this.props.appointmentDetails[this.props.procedure.appointment.id].response);
    this.props.closeModal();
  };

  onReBook = () => {
    const currentAppointmentCard = document.querySelector('.cal-entry-wrap.cal-active.current-card');
    if (currentAppointmentCard) currentAppointmentCard.style.zIndex = '404';

    const appointmentId = getAnyOrVoid('procedure.appointment.id', this.props);
    const response = getAnyOrVoid(['appointmentDetails', appointmentId, 'response'], this.props);

    L.debug('onReBook()', { appointmentId, response });

    const oldAppointment = { ...response };
    if (!this.state.isCancelling) deepFreeze(oldAppointment);

    this.setState({ showRebookComponent: true, oldAppointment });
    this.setState({ modalCheckout: false });
  };

  onRescheduleBooking = () => void this.onEditBooking({ reschedule: true });
  onchargeDepositClick = () => void this.setState({ btnClassActive: true, chargeFeeModal: true });

  onBlur = () => void this.setState({ dropdownModal: false });
  onRevertClick = () => void this.setState({ revertModal: !this.state.revertModal });
  onRevertBlur = () => void this.setState({ revertModal: false });

  onConfirmCharge = (depositData, amount, chargeType) => {
    const action = CHARGE_TO_DEPOSIT[chargeType];

    if (amount && action === DEPOSIT_ACTION.bankCharges) {
      this.chargeDeposit(amount, action);
    } else if (depositData && depositData.amount && !this.state.deleteBooking) {
      this.onStatusChange(AP_STATUS.noShow, action, depositData.amount, depositData);
    }

    if (depositData && depositData.amount && this.state.deleteBooking) {
      this.onStatusChange(AP_STATUS.deleted, action, depositData.amount, depositData);
    } else if (this.state.deleteBooking && depositData && !depositData.amount) {
      this.onStatusChange(AP_STATUS.deleted, action, amount);
    }
  };

  onDepositRequest = (deposit, cardOnly) => {
    this.setState({ modalRequestDeposit: false, modalRequestSend: true });
    const appointment = this.props.procedure.appointment;
    const salonId = this.props.salonId;
    this.props.requestDeposit(appointment, deposit, cardOnly, salonId);
  };

  onRequestPayments = () => {
    this.props.history.push(`/salon/${this.props.salonId}/onlinebooking`);
  };
  closeNoSmsCreditModal = () => {
    this.setState({ modalNoSmsCredit: false });
  };
  expandedText = () => {
    this.setState({ expanded: !this.state.expanded });
    const servicesContainer = document.querySelector('.reverse-services-list-order');
    if (servicesContainer) {
      if (this.state.expanded !== true) {
        servicesContainer.style.maxHeight = '100%'; // if notes are expanded, no scroll no revert button
      } else {
        servicesContainer.style.maxHeight = '98px';
      }
    }
  };
  gotoBilling = () => {
    const oldpath = this.props.history.location.pathname;
    let newPath;
    if (oldpath.indexOf('day') > 0) {
      newPath = `${oldpath.split('day/')[0]}settings/billing`;
    } else if (oldpath.indexOf('communications') > 0) {
      newPath = `${oldpath.split('communications/')[0]}settings/billing`;
    } else {
      newPath = `${oldpath.split('week/')[0]}settings/billing`;
    }
    this.props.history.push({ pathname: newPath });
  };

  SwitchStatus = (statusParam) => {
    const appointment = this.props.appointmentDetails[this.props.procedure.appointment.id];
    switch (statusParam) {
      case 'confirmed':
        if (appointment && appointment.success && appointment.response) {
          if (appointment.response.origin === 'online_booking') {
            return <div style={{ color: '#192340' }}>Confirmed by Client SMS</div>;
          }
        }
        return <div style={{ color: '#192340' }}>Confirmed in Salon</div>;
      case 'unconfirmed':
        if (appointment && appointment.success && appointment.response) {
          if (appointment.response.origin === 'online_booking') {
            return <div style={{ color: '#192340' }}>Customer verified</div>;
          }
        }
        return <div style={{ color: '#192340' }}>Unconfirmed</div>;
      case 'arrived':
        return <div style={{ color: '#192340' }}>Go to checkout to complete booking</div>;
      case 'finished':
        return <div style={{ color: '#e9081d' }}>Press checkout to take payment</div>;
      case 'paid':
        return <div />;
      case 'update':
        return <div style={{ color: '#e9081d' }}>Has your client arrived?</div>;
      case 'canceled':
        return <div style={{ color: '#f73746' }}>Cancelled</div>;
      case 'no_show':
        return <div style={{ color: '#192340' }}>No Show</div>;
      case 'customer_unverified':
        return <div>Customer Unverified</div>;
      case 'preferred':
        return <div />;
      case 'error':
        return 'Fix me';
      default:
        return null;
    }
  };

  canChargeNoshow = () => {
    const hoursLeftToAppointment = moment(this.props.procedureStartTime).diff(moment(), 'hours');
    return hoursLeftToAppointment < 48;
  };

  checkIsLoading = () => {
    const { procedure, clientViewData, appointmentDetails } = this.props;

    const appointmentId = procedure?.appointment?.id;
    const isFetching = appointmentDetails[appointmentId]?.isFetching;

    return fromAnyToBool(isFetching ? true : clientViewData.isFetching);
  };

  StatusBgrImage = (item) => {
    switch (item) {
      case 'confirmed':
        return <div className="status-img confirmIcon" />;
      case 'arrived':
        return <div className="status-img handUpIcon" />;
      case 'finished':
        return <div className="status-img basketIcon" />;
      case 'paid':
        return <div className="status-img handUpIcon" />;
      case 'canceled':
        return <div className="status-img handDownIcon" />;
      case 'no_show':
        return <div className="status-img handDownIcon" />;
      default:
        return null;
    }
  };

  RequestDeposit = () => {
    const stoppedSms = this.props.appointmentDetails[this.props.procedure.appointment.id].response.client.stopped_sms;

    if (stoppedSms) {
      this.setState({ smsStoppedModal: true });
    } else if (!this.props.has_ncob_stripe_account) {
      this.RequestDepositSetupPayment();
    } else if (this.props.sms_credits_available) {
      this.setState({ modalRequestDeposit: true });
    } else {
      this.setState({ modalNoSmsCredit: true });
    }
  };

  RequestDepositSetupPayment = () => void this.setState({ modalSetupPaymentAccount: true });

  revertProcedure = (ev) => {
    const pk = ev?.pk;
    const { revertProcedureLog, salonId, procedure, showModal, closeModal } = this.props;
    const procedureId = procedure?.id;

    call('ProcedureModal.revertProcedure', closeModal);

    const Modal = ({ onRequestClose }) => (
      <ConfirmationDialog
        onRequestClose={onRequestClose}
        title="Move appointment back?"
        leftButtonText="CANCEL"
        rightButtonText="CONFIRM"
        onLeft={onRequestClose}
        onRight={() => {
          call('ProcedureModal.revertProcedureLog', revertProcedureLog, salonId, procedureId, pk);
          call('ProcedureModal.onRequestClose', onRequestClose);
        }}
        onCancel={onRequestClose}
      >
        <p>
          You are about to move this booking back to a previously selected time. Are you sure you would like to continue
          with this?(You can change this back at any time).
        </p>
      </ConfirmationDialog>
    );

    showModal(Modal, {});
  };

  loadPreference = () => {
    const interval = setInterval(() => {
      const appointmentStatus = this.props.appointmentDetails[this.props.procedure.appointment.id]
        ? this.props.appointmentDetails[this.props.procedure.appointment.id]
        : {
            isFetching: false,
            success: false,
            error: { message: 'Failed fetch request' },
          };
      const linkedProceduresNotSorted = appointmentStatus.success ? appointmentStatus.response.procedures : [];
      if (linkedProceduresNotSorted.length > 0) {
        if (
          linkedProceduresNotSorted[0].appointment &&
          linkedProceduresNotSorted[0].appointment.client &&
          linkedProceduresNotSorted[0].appointment.client.id
        ) {
          clearInterval(interval);
          this.setState({ loadPreference: true });
          this.props.getPreferenceList(this.props.salonId, linkedProceduresNotSorted[0].appointment.client.id);
        }
      }
    }, 100);
  };

  chargeDeposit = async (amount, action = '') => {
    const FTAG = 'chargeDeposit()';

    const { salonId, beChargeCardOnFile } = this.props;

    const isFetching = getAnyOrVoid('clientViewData.isFetching', this.props);
    const depositsList = getAnyOrVoid('clientViewData.response.deposits_list', this.props);
    const appointmentId = getAnyOrVoid('procedure.appointment.id', this.props);
    const clientId = getAnyOrVoid('procedure.appointment.client.id', this.props);

    // try to find if there is a deposit made for this appointment
    const depositData =
      isFetching || !isFullArray(depositsList)
        ? null
        : depositsList.find(({ created_for_appointmentId }) => created_for_appointmentId === appointmentId);

    if (!clientId || action !== DEPOSIT_ACTION.bankCharges) {
      return;
    }

    try {
      const options = { salonId, clientId, appointmentId, amount, isNoShowFee: true };
      const result = L.debug(FTAG, 'result:', await beChargeCardOnFile(options));

      const chargeSuccess = getAnyOrVoid('response.success', result);
      const httpStatusCode = getAnyOrVoid('actualResponse.status', result);

      if (!result.is.ok || !chargeSuccess) {
        L.warn(FTAG, { result, chargeSuccess, httpStatusCode });
        this.setState({ errorMessage: EMSG.txCreate });
        return;
      }
    } catch (error) {
      L.warn(FTAG, error);
      this.setState({ errorMessage: EMSG.txCreate });
      throw error;
    }

    this.onStatusChange(AP_STATUS.noShow, action, amount, depositData);
  };

  clearErrorMessage = () => this.setState({ errorMessage: S.empty });

  showRebook = (showRebookComponent) => void this.setState({ showRebookComponent });
  handleSendText = () => void this.setState({ showSms: true });

  showSmsPopup = (showSms) => {
    const stoppedSms = this.props.appointmentDetails[this.props.procedure.appointment.id].response.client.stopped_sms;

    if (stoppedSms) {
      this.setState({ smsStoppedModal: true });
    } else {
      this.setState({ showSms });
    }
  };

  hideNoBilling = () => void this.setState({ isBillingRendered: false });
  showNoBilling = () => void this.setState({ isBillingRendered: true });

  render() {
    const { errorMessage: errorMessageFromState, showRebookComponent, isBillingRendered } = this.state;
    const { errorMessage: errorMessageFromProps, status: statusFromProps, hasBetaAnnualSalon, hasBilling } = this.props;

    const serviceClass = cn('cal-service', { 'cal-txt-w': ['no_show', 'error'].includes(statusFromProps) });
    const serviceIconClass = cn('cal-service-icon', {
      'cal-state-a': ['unconfirmed', 'confirmed', 'online_unconfirmed'].includes(statusFromProps),
      'cal-state-b': ['arrived', 'not_arrived'].includes(statusFromProps),
      'cal-state-c': ['finished', 'paid'].includes(statusFromProps),
      'cal-state-d': ['no_show', 'canceled'].includes(statusFromProps),
      'cal-state-f': ['error'].includes(statusFromProps),
    });

    const noshowBtnDisabled = !this.canChargeNoshow();
    const appointmentStatus = this.props.appointmentDetails[this.props.procedure.appointment.id]
      ? this.props.appointmentDetails[this.props.procedure.appointment.id]
      : {
          isFetching: false,
          success: false,
          error: { message: 'Failed fetch request' },
        };

    let invitationStatus;
    let invitationDate;

    const response = appointmentStatus.response;

    if (response && response.invitation) {
      const invitation = response.invitation;
      invitationStatus = invitation.status;
      if (Object.keys(invitation).length > 0) {
        if (invitationStatus === 'invited') {
          invitationDate = moment(invitation.created_at).format('MMMM Do');
        } else if (invitationStatus === 'reminded') {
          invitationDate = moment(invitation.reminder_sent_at).format('MMMM Do');
        } else if (invitationStatus === 'declined') {
          invitationDate = '';
        }
      }
    }
    let patchDateArrHour;
    let patchDateArrData;

    if (response && response.patch_test_date_time && response.date_created) {
      patchDateArrHour = moment(response.patch_test_date_time).format('h:mma').split(',');
      patchDateArrData = moment(response.patch_test_date_time).format(' ddd, Do MMM').split(',');
    }
    const patchTimeHtml = patchDateArrHour;
    const patchDateHtml = patchDateArrData;

    const linkedProceduresNotSorted = appointmentStatus.success ? response.procedures : [];
    let creationDateArr;
    let creationDate = '';
    let creationHour = '';
    if (response && response.date_created) {
      creationDateArr = moment(response.date_created).format('ddd, Do MMM, kk:mm').split(',');
      creationDate = `${creationDateArr[0]} ${creationDateArr[1]}`;
      creationHour = ` at ${creationDateArr[2]}`;
    }

    const appointment = Object.assign({}, this.props.appointmentDetails[this.props.procedure.appointment.id]);

    if (
      appointment &&
      appointment.success &&
      appointment.response /* && appointment.response.status !== 'canceled' */
    ) {
      appointment.creationDate = creationDate + creationHour;
    }

    const linkedProcedures = linkedProceduresNotSorted.slice();
    let total = 0;
    linkedProcedures.map((p) => {
      total += p.price;
      return null;
    });

    let depositData = null;

    const deposit = this.props.procedure.appointment.deposit;
    // try to find if there is a deposit made for this appointment
    if (
      !this.props.clientViewData.isFetching &&
      this.props.clientViewData.response &&
      this.props.clientViewData.response.deposits_list
    ) {
      depositData = this.props.clientViewData.response.deposits_list.find(
        (dep) => dep.created_for_appointmentId === this.props.procedure.appointment.id,
      );

      if (deposit === 'refunded') {
        if (!depositData) depositData = {};
        depositData.refundAmount = depositData.amount;
      }
    }

    let isFetchingServices = false;
    if (
      this.props.appointmentDetails[this.props.procedure.appointment.id] &&
      this.props.appointmentDetails[this.props.procedure.appointment.id].isFetching
    ) {
      isFetchingServices = true;
    }
    const currentAppointment = this.props.appointmentDetails[this.props.procedure.appointment.id];
    let clientStatus = '';
    let clientHasCard = '';
    let userName = '';
    if (currentAppointment && currentAppointment.response && currentAppointment.response.client) {
      clientStatus = currentAppointment.response.client.status;
      clientHasCard = currentAppointment.response.client.active_card;
      userName = currentAppointment.response.client.user_name;
    }

    const isRepeating = this.props.procedure.appointment.is_repeating;
    const {
      modalCheckout,
      modalCancel,
      modalIsOpen,
      chargeFeeModal,
      modalRequestDeposit,
      modalDeleteCurrentBooking,
      modalSetupPaymentAccount,
      smsStoppedModal,
    } = this.state;

    const onRequestClose = (noCharge) => {
      this.setState({
        modalCheckout: false,
        modalCancel: false,
        modalIsOpen: false,
        noShowModal: false,
        chargeFeeModal: false,
        confirmChargeFail: false,
        bankSuccessModal: false,
        modalRequestDeposit: false,
        modalSetupPaymentAccount: false,
        modalClientNoPhone: false,
        smsStoppedModal: false,
        modalDeleteCurrentBooking: false,
      });
      if (noCharge === 'no charge') {
        if (!this.state.deleteBooking) {
          this.onStatusChange(AP_STATUS.noShow);
        } else {
          this.onStatusChange(AP_STATUS.deleted);
        }
      }
    };

    let phone;
    if (
      Object.keys(this.props.appointmentDetails).length &&
      this.props.procedure.appointment.client &&
      this.props.procedure.appointment.client.id &&
      this.props.appointmentDetails[this.props.procedure.appointment.id] &&
      this.props.appointmentDetails[this.props.procedure.appointment.id].response
    ) {
      phone = this.props.appointmentDetails[this.props.procedure.appointment.id].response.client.phone;
    }

    let showRequestDeposit = true;
    if (
      depositData ||
      !phone ||
      moment(this.props.procedure.start_time).isBefore(moment()) ||
      ['active', 'unconfirmed', 'customer_unverified', 'arrived', 'confirmed'].indexOf(
        this.props.procedure.appointment.status,
      ) < 0
    ) {
      showRequestDeposit = false;
    }

    const notes = this.props.procedure.appointment.notes;
    const maxNotesChar = 28;
    const clientId = getAny(null, 'procedure.appointment.client.id', this.props);
    const clientName = getAny(null, 'procedure.appointment.client.user_name', this.props);

    const isAfterToday = moment(this.props.currentTime).diff(moment(), 'd') >= 1;

    const deleteAppointmentButton = this.props.procedure.appointment.is_repeating
      ? this.onDeleteAllClicked
      : this.onDeleteCurrent;

    return (
      <div data-bem="ProcedureModal">
        <div
          data-bem="ProcedureModal__close-button"
          data-procedure-modal="close"
          className="close-card-overlay"
          role="button"
          tabIndex={0}
          onClick={this.props.closeModal}
        />
        <div data-bem="ProcedureModal__body" data-procedure-modal="card" className="card-modal-wraper animated zoomIn">
          <CardModalHeader
            tag="ProcedureModal"
            onClose={this.props.closeModal}
            style={{ backgroundColor: this.props.backgroundColor }}
          >
            {isTruthy(clientId) && clientStatus !== 'deleted' ? (
              <div className="card-action-btns">
                <DeleteAppointmentButton onClick={deleteAppointmentButton} />
                {statusFromProps === 'paid' ? (
                  <div />
                ) : (
                  <>
                    {statusFromProps !== 'canceled' && statusFromProps !== 'no_show' && (
                      <button
                        onClick={() =>
                          void this.onStatusChange(
                            statusFromProps === AP_STATUS.confirmed ? AP_STATUS.unconfirmed : AP_STATUS.confirmed,
                          )
                        }
                        className="btn-confirm-booking"
                      >
                        {statusFromProps === 'confirmed' ? (
                          <img src={unconfirmed} alt="Booking Unconfirm" />
                        ) : (
                          <img src={confirmed} alt="Booking confirmed" />
                        )}
                        {statusFromProps === 'confirmed' ? <span>Unconfirm</span> : <span>Confirm</span>}
                      </button>
                    )}
                  </>
                )}

                <div className="sms-card-header-btn">
                  {fromAnyToBool(clientId) && (
                    <button
                      className="sms-compose-button"
                      onClick={!hasBilling && !hasBetaAnnualSalon ? this.showNoBilling : this.handleSendText}
                    >
                      <span>
                        <img src={smsIco} alt="" />
                        <span>Send text</span>
                      </span>
                    </button>
                  )}
                </div>
              </div>
            ) : (
              clientStatus !== 'deleted' && (
                <div className="card-action-btns walk-in">
                  {/* walk in selection */}
                  <DeleteAppointmentButton onClick={deleteAppointmentButton} />
                  <button
                    onClick={() =>
                      void this.onStatusChange(
                        statusFromProps === AP_STATUS.confirmed ? AP_STATUS.unconfirmed : AP_STATUS.confirmed,
                      )
                    }
                    className="btn-confirm-booking"
                  >
                    {statusFromProps === 'confirmed' ? (
                      <img src={unconfirmed} alt="Booking Unconfirm" />
                    ) : (
                      <img src={confirmed} alt="Booking confirmed" />
                    )}
                    {statusFromProps === 'confirmed' ? <span>Unconfirm</span> : <span>Confirm</span>}
                  </button>
                </div>
              )
            )}

            <div className="status-bgr">
              {statusFromProps === 'no_show' ||
              statusFromProps === 'arrived' ||
              statusFromProps === 'confirmed' ||
              statusFromProps === 'canceled' ||
              statusFromProps === 'paid' ||
              statusFromProps === 'finished' ? (
                <div> {this.StatusBgrImage(statusFromProps)}</div>
              ) : (
                <div>
                  {response && response.origin && (
                    <div className="appointment-img">
                      <img src={STATUS_BOOKING_IMG[response.origin]} alt={STATUS_BOOKING[response.origin]} />
                    </div>
                  )}
                  {this.props.isClientBirthdayToday === true ? (
                    <div
                      className={this.props.isClientBirthdayToday === true ? 'status-img birthdayIcon' : 'status-image'}
                    />
                  ) : (
                    <div />
                  )}
                </div>
              )}
            </div>

            <div className="client-info">
              {clientId ? (
                <div>
                  {clientStatus !== 'deleted' && (
                    <>
                      <div className="name">
                        {this.props.isClientBirthdayToday === true ? (
                          <div className="text-lowercase">
                            It’s <strong>{clientName}</strong>
                            ’s Birthday Today!
                          </div>
                        ) : (
                          <div onClick={this.onViewClientProfile} role="button" tabIndex={-1}>
                            {clientName}
                          </div>
                        )}
                      </div>
                      <div className="phone-email">
                        {this.props.hideDetails ? <span>{phone && fromStringToXs(phone)}</span> : <span>{phone}</span>}
                      </div>
                      <span
                        data-bem="ProcedureModal__view-client-profile"
                        className="link-to-profile"
                        onClick={this.onViewClientProfile}
                        role="button"
                        tabIndex={-1}
                      >
                        View client profile
                      </span>
                    </>
                  )}
                  {clientStatus === 'deleted' && (
                    <div className="name">
                      <div>Deleted Client</div>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <div className="name">Walk In</div>
                </div>
              )}
            </div>
          </CardModalHeader>

          <CardModalContent>
            <SalonFlag name={SF.clientTags}>
              <SalonFlag.IfEnabled>
                {fromAnyToBool(this.props.clientTags) && <ShowTags tagList={this.props.clientTags} />}
              </SalonFlag.IfEnabled>
            </SalonFlag>
            <div className="client-profile-notes-55 client-note">
              {notes && (
                <div className={this.state.expanded ? 'expandable-container open' : 'expandable-container '}>
                  <span className={this.state.expanded ? 'note-text' : 'note-text clip'}>
                    <strong>Booking note:&nbsp;</strong> {notes}
                  </span>

                  {notes.length > maxNotesChar ? (
                    <span
                      role="button"
                      tabIndex={0}
                      className="show-more-text"
                      onClick={() => {
                        this.expandedText();
                      }}
                    >
                      {this.state.expanded ? 'close' : '...more'}
                    </span>
                  ) : (
                    <div />
                  )}
                </div>
              )}
            </div>
            {/* combining/wraping  appointment status with card status in one tag */}
            <div className="origin-container">
              {response && response.origin && (
                <div>
                  {!appointment.response.created_by ? (
                    <p>
                      {STATUS_BOOKING[response.origin]}&nbsp;on&nbsp;{appointment.creationDate}
                    </p>
                  ) : (
                    <p>
                      <span>{STATUS_BOOKING[response.origin]}</span>
                      <span>&nbsp;by&nbsp;</span>
                      <span>{appointment.response.created_by}</span>
                      <span className="new-line">on {appointment.creationDate}</span>
                    </p>
                  )}
                  {isRepeating && (
                    <div>
                      {`Repeats every ${appointment.response.frequency} weeks until ${moment(
                        appointment.response.until,
                      ).format('Do MMM YYYY')}`}
                    </div>
                  )}
                </div>
              )}
            </div>
            {response && response.patch_test_date_time ? (
              <div className="patch-date-time">
                Patch test booked for {patchTimeHtml} on {patchDateHtml}
              </div>
            ) : null}
            <div className="status-container">
              {(statusFromProps === 'no_show' ||
                statusFromProps === 'arrived' ||
                statusFromProps === 'confirmed' ||
                statusFromProps === 'unconfirmed' ||
                statusFromProps === 'canceled' ||
                statusFromProps === 'paid' ||
                statusFromProps === 'finished' ||
                statusFromProps === 'customer_unverified') && <div>{this.SwitchStatus(statusFromProps)}</div>}
            </div>
            <div className="static-container">
              <div className="date-apointment">
                <div className="time">
                  {statusFromProps !== 'paid' ? (
                    <img src={calIcon} alt="Calendar icon" />
                  ) : (
                    <img src={calIcon} alt="Calendar icon" style={{ opacity: 0.4 }} />
                  )}

                  {this.props.procedureStartTime.format('dddd D MMM')}
                  <span>
                    {this.props.procedureStartTime.format('h:mm')} - {this.props.procedureEndTime.format('h:mm a')}
                  </span>
                </div>
                <RevertButton
                  onRevertProcedure={this.revertProcedure}
                  onOpen={this.onRevertClick}
                  onClose={this.onRevertBlur}
                  procedureId={this.props.procedure?.id}
                  withRevert={this.state.revertModal}
                />
              </div>

              {this.props.appointmentDetails[this.props.procedure.appointment.id] &&
                this.props.appointmentDetails[this.props.procedure.appointment.id].isFetching && (
                  <div className="deposit-paid  cfix">
                    <div className="label-name"> Loading services....</div>
                  </div>
                )}

              <div className="reverse-services-list-order">
                {linkedProcedures.map((procedure) => {
                  const isPreferred = asArray(this.props.preferenceList).some(
                    (p) => p.service === procedure?.service?.id && p.stylist === procedure?.stylist?.id,
                  );
                  return (
                    <div
                      role="button"
                      tabIndex={0}
                      className="services-list"
                      key={procedure.id}
                      onClick={() => {
                        this.onPreferredClick(procedure.service.id);
                      }}
                    >
                      <div className="services-elm cfix">
                        {statusFromProps !== 'paid' && (
                          <div className="hover-heart">
                            <HeartIcon
                              tag="BookingLogPanel__heart"
                              backgroundColor={procedure.service.category.color}
                              isHeartFilled={isPreferred}
                            />

                            {clientId && (
                              <PreferencesTooltip
                                text={isPreferred ? 'Stylist requested' : 'Stylist not requested'}
                                backgroundColor={procedure.service.category.color}
                              />
                            )}
                          </div>
                        )}

                        <div className={serviceClass}>
                          <div className="label-name">
                            {procedure.service.name && <div className={serviceIconClass} />}
                          </div>
                          <div className="label-name">
                            {procedure.service.name && <div className="name">{procedure.service.name}</div>}
                            <span>
                              with&nbsp;
                              {procedure.stylist.user_name}
                            </span>
                            <div className="services-price">
                              <CurrencySign />
                              {procedure.price}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </CardModalContent>

          <CardModalFooter>
            {depositData && !depositData.refundAmount ? (
              <div className="total cfix">
                {statusFromProps !== 'paid' && (
                  <div className="total-paid cfix">
                    <small>Total to Pay</small>
                    <strong>
                      <CurrencySign />
                      {parsfixed(total - depositData.amount)}
                    </strong>
                  </div>
                )}
              </div>
            ) : (
              <div className="total cfix 2">
                {statusFromProps !== 'paid' && (
                  <div className="total-paid cfix">
                    <small>Total to Pay</small>
                    <strong>
                      <CurrencySign />
                      {parsfixed(total)}
                    </strong>
                  </div>
                )}
              </div>
            )}
            <div className="deposit-request-banner">
              {/* deposit request */}
              {this.props.clientViewData.isFetching && (
                <div className="deposit-paid  cfix">
                  <div className="label-name"> Loading deposit info....</div>
                </div>
              )}
              <div>
                {depositData &&
                  (depositData.source === 'cash' ||
                    depositData.source === 'card' ||
                    depositData.source === 'other' ||
                    depositData.source === 'slick_pos') &&
                  depositData.amount &&
                  !depositData.refundAmount && (
                    <div className="deposit-paid  cfix">
                      <div className="label-name"> Deposit Paid in-store</div>
                      <div className="services-price">
                        <CurrencySign />
                        {parseFloat(depositData.amount)}
                      </div>
                    </div>
                  )}
                {depositData &&
                  depositData.source === 'online' &&
                  depositData.amount !== 0 &&
                  !depositData.refundAmount && (
                    <div className="deposit-paid-online-banner  cfix">
                      {/* green */}
                      <div className="label-name">Online deposit paid via Slick</div>
                      <div className="services-price">
                        <CurrencySign />
                        {parseFloat(depositData.amount)}
                      </div>
                    </div>
                  )}
                {depositData &&
                  (depositData.source === 'cash' || depositData.source === 'card') &&
                  deposit === 'refunded' &&
                  depositData.refundAmount && (
                    <div
                      className="deposit-paid  d-refunded cfix"
                      style={
                        { backgroundColor: '#9e034c' } // dark red
                      }
                    >
                      <div className="label-name"> Deposit refunded</div>
                      <div className="services-price">
                        <CurrencySign />
                        {parseFloat(depositData.refundAmount)}
                      </div>
                    </div>
                  )}
                {depositData &&
                  depositData.source === 'online' &&
                  deposit === 'refunded' &&
                  depositData.refundAmount && (
                    <div
                      className="deposit-paid-online-banner  cfix"
                      style={
                        { backgroundColor: '#9e034c' } // dark red
                      }
                    >
                      <div className="label-name">Deposit refunded</div>
                      <div className="services-price">
                        <CurrencySign />
                        {parseFloat(depositData.refundAmount)}
                      </div>
                    </div>
                  )}
              </div>
              {/* deposit error */}
              {!this.props.clientViewData.isFetching && this.props.clientViewData.errorMessage && (
                <div className="deposit-paid  cfix">
                  <div className="label-name">
                    Error retrieving deposit info: {this.props.clientViewData.errorMessage}
                  </div>
                </div>
              )}
            </div>
            {statusFromProps === 'paid' && (
              <div className="modal-buttons">
                {invitationStatus === 'accepted' && (
                  <div id="deposit-online-banner">
                    <span>DEPOSIT REQUEST ACCEPTED</span>
                  </div>
                )}

                {!isFetchingServices && clientId && (
                  <div className={CN.buttonRowContainer}>
                    <Button width="auto" variant="outline" onClick={this.onReBook}>
                      RE-BOOK NOW
                    </Button>
                  </div>
                )}
              </div>
            )}

            {statusFromProps !== 'paid' && statusFromProps !== 'no_show' && (
              <div className="modal-buttons">
                {invitationStatus === 'reminded' && invitationDate && (
                  <div id="deposit-reminder-send-banner">
                    <span>{`DEPOSIT REMINDER SENT ${invitationDate}`} </span>
                  </div>
                )}
                {invitationStatus === 'invited' && (
                  <div id="deposit-send-banner">
                    {invitationDate && <span>{`DEPOSIT REQUEST SENT ${invitationDate}`} </span>}
                  </div>
                )}
                {invitationStatus === 'declined' ? (
                  <div id="deposit-declined-banner">
                    <div className="label-name">Deposit request declined</div>
                  </div>
                ) : (
                  <ToggleFeature flag="showRequestDeposit">
                    {showRequestDeposit && !invitationDate && (
                      <div className="no-deposit-taken-banner  cfix">
                        <div className="label-name">No deposit taken</div>
                        <button
                          id="request-deposit-btn"
                          className="btn btn-white deposit-setup"
                          onClick={this.RequestDeposit}
                        >
                          <span>Request deposit</span>
                        </button>
                      </div>
                    )}
                  </ToggleFeature>
                )}

                {this.props.procedure.appointment.status !== 'canceled' && (
                  <div className="cfix card-footer-btns">
                    {fromAnyToBool(this.state.footerButtons) && (
                      <>
                        <div className={CN.buttonRowContainer}>
                          <Button
                            tag="ProcedureModal__cancel-button"
                            width="auto"
                            variant={
                              !isAfterToday || clientHasCard || (depositData && depositData.amount)
                                ? 'outline'
                                : 'primary'
                            }
                            onClick={this.onCancelClick}
                          >
                            <span className={CN.buttonInner}>
                              {S.crossMark}
                              <Space>CANCEL</Space>
                            </span>
                          </Button>

                          {!isAfterToday ? (
                            <>
                              {clientHasCard || (depositData && depositData.amount) ? (
                                <Button
                                  tag="ProcedureModal__noshow-button--card"
                                  width="auto"
                                  variant={this.state.btnClassActive ? 'primary' : 'outline'}
                                  onClick={() => this.onchargeDepositClick(clientHasCard)}
                                  disabled={noshowBtnDisabled || statusFromProps === 'no_show'}
                                >
                                  <span className={CN.buttonInner}>
                                    {S.dislike}
                                    <Space>NO SHOW</Space>
                                  </span>
                                </Button>
                              ) : (
                                <Button
                                  tag="ProcedureModal__noshow-button--nocard"
                                  width="auto"
                                  disabled={
                                    noshowBtnDisabled || statusFromProps === 'no_show' // No deposit, No card
                                  }
                                  variant={this.state.btnClassActive ? 'primary' : 'outline'}
                                  onClick={() => this.onchargeDepositClick('')}
                                >
                                  <span className={CN.buttonInner}>
                                    {S.dislike}
                                    <Space>NO SHOW</Space>
                                  </span>
                                </Button>
                              )}
                            </>
                          ) : null}

                          {clientStatus !== 'deleted' && !isAfterToday && (
                            <Button
                              tag="ProcedureModal__arrived-button"
                              width="auto"
                              variant={
                                ['arrived', 'paid', 'finished'].includes(this.props.procedure.appointment.status)
                                  ? 'primary'
                                  : 'outline'
                              }
                              onClick={() => {
                                if (this.checkIsLoading()) {
                                  return;
                                }
                                if (statusFromProps === 'arrived') {
                                  this.props.handleStatusChange('unconfirmed');
                                } else {
                                  this.props.handleStatusChange('arrived');
                                  this.props.closeModal();
                                }
                              }}
                            >
                              <span className={CN.buttonInner}>
                                {S.like}
                                <Space>ARRIVED</Space>
                              </span>
                            </Button>
                          )}
                        </div>
                        <div className={CN.buttonRowContainer}>
                          <Button
                            tag="ProcedureModal__edit-button"
                            width="auto"
                            data-cy="edit-booking-btn"
                            variant="outline"
                            onClick={() => this.onEditBooking({ reschedule: false })}
                          >
                            <span className={CN.buttonInner}>EDIT</span>
                          </Button>
                          <Button
                            tag="ProcedureModal__reschedule-button"
                            width="auto"
                            variant="outline"
                            onClick={this.onRescheduleBooking}
                          >
                            <span data-bem="ProcedureModal__reschedule-text" className={CN.buttonInner}>
                              RESCHEDULE
                            </span>
                          </Button>
                        </div>
                        <div className={CN.buttonRowContainer}>
                          {clientId ? (
                            <>
                              {statusFromProps !== 'paid' &&
                                !isFetchingServices &&
                                moment(this.props.procedure.start_time).isSameOrBefore(moment().endOf('day')) && (
                                  <Button
                                    tag="ProcedureModal__checkout-rebook-button"
                                    width="auto"
                                    data-cy="checkout-btn"
                                    variant="outline"
                                    onClick={this.onCheckoutClick}
                                  >
                                    <span className={CN.buttonInner}>Checkout & Rebook</span>
                                  </Button>
                                )}
                            </>
                          ) : (
                            <>
                              {statusFromProps !== 'paid' &&
                                !isFetchingServices &&
                                moment(this.props.procedure.start_time).isSameOrBefore(moment().endOf('day')) && (
                                  <Button
                                    tag="ProcedureModal__checkout-button--old-modal"
                                    width="auto"
                                    data-cy="checkout-btn"
                                    variant="outline"
                                    onClick={this.onCheckoutWalking}
                                  >
                                    <span className={CN.buttonInner}>Checkout</span>
                                  </Button>
                                )}
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            )}
          </CardModalFooter>
        </div>
        <SalonModal tag="ProcedureModal.errorMessageFromState" isOpen={fromAnyToBool(errorMessageFromState)}>
          <SalonModal.Body>
            <DialogMessage>{errorMessageFromState}</DialogMessage>
          </SalonModal.Body>
          <SalonModal.Footer>
            <Button variant="slim" variantInvert onClick={this.clearErrorMessage}>
              Close
            </Button>
          </SalonModal.Footer>
        </SalonModal>
        {smsStoppedModal && (
          <AlertDialog title="" buttonText="Close" onClick={onRequestClose} onClose={onRequestClose}>
            <SmsStoppedTextComponent />
          </AlertDialog>
        )}
        <SalonModal tag="ProcedureModal__modal--re-book" isOpen={modalCheckout} withFooter>
          <SalonModal.Header>
            <div className={CN.closeButtonContainer}>
              <Button variant="empty" onClick={onRequestClose}>
                <Icon variant="close" variantInvert />
              </Button>
            </div>
          </SalonModal.Header>
          <SalonModal.Body>
            <IconStatus variant="info" width="lg">
              <Icon variant="calendarEmpty" selected width="l1" variantInvertDark />
            </IconStatus>
            <div className={CN.modalContent}>
              <div className={CN.modalTitle}>Re-book next appointment?</div>
              <span className={CN.modalText}>
                By re-booking before checkout, your client will have their next appointment details in their email.
              </span>
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            <div className={CN.modalButtonsRight}>
              <Button
                tag="ProcedureModal__checkout-button--new-modal"
                variant="outlineForce"
                onClick={this.onCheckoutFromModal}
                xSpace
              >
                GO TO CHECKOUT
              </Button>
              <Button tag="ProcedureModal__rebook-button" variant="primaryForce" onClick={this.onReBook} xSpace>
                RE-BOOK CLIENT
              </Button>
            </div>
          </SalonModal.Footer>
        </SalonModal>

        <SalonModal tag="ProcedureModal__modal--confirm-cancellation" isOpen={modalCancel} withFooter isHighlighted>
          <SalonModal.Body>
            <IconStatus variant="warning" width="lg">
              <Icon variant="calendarEmptyRed" selected width="l1" />
            </IconStatus>
            <div className={CN.modalContent}>
              <div className={CN.modalTitle}>Confirm appointment cancellation</div>
              <div className={CN.modalText}>This slot will become available for other clients to book.</div>
              {clientHasCard || (depositData && depositData.amount) ? (
                <div />
              ) : (
                <div className={CN.modalTextAlert}>
                  Get protection from last minute cancellations by enabling Online Deposits in Online Booking &
                  Payments.
                </div>
              )}
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            <div className={CN.modalButtons}>
              <Button variant="outlineForce" onClick={onRequestClose} xSpace>
                GO BACK
              </Button>
              <Button variant="alert" onClick={() => void this.onConfirmCancel(depositData, clientHasCard)} xSpace>
                CANCEL APPOINTMENT
              </Button>
            </div>
          </SalonModal.Footer>
        </SalonModal>
        <SalonModal tag="ProcedureModal__modal--delete-repeating-booking" isOpen={modalIsOpen} withFooter>
          <SalonModal.Header>
            <div className={CN.closeButtonContainer}>
              <Button variant="empty" onClick={onRequestClose}>
                <Icon variant="close" variantInvert />
              </Button>
            </div>
          </SalonModal.Header>
          <SalonModal.Body>
            <IconStatus variant="warning" width="lg">
              <Icon variant="arrowPath" selected width="l1" />
            </IconStatus>
            <div className={CN.modalContent}>
              <div className={CN.modalTitle}>Delete repeat booking</div>
              <div className={CN.modalTextGap}>
                You can delete all of the repeated bookings OR this selected booking
              </div>
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            <div className={CN.modalButtons}>
              <Button
                tag="ProcedureModal__delete-all-button"
                variant="outlineForce"
                onClick={() => this.onDeleteAll(true)}
                xSpace
              >
                DELETE ALL
              </Button>
              <Button
                tag="ProcedureModal__delete-all-button"
                variant="alert"
                onClick={() => {
                  this.onDelete(depositData ? depositData.amount : 0, clientHasCard, true);
                  this.setState({ modalIsOpen: false });
                }}
                xSpace
              >
                DELETE SELECTED ONLY
              </Button>
            </div>
          </SalonModal.Footer>
        </SalonModal>

        <SalonModal
          tag="ProcedureModal__modal--delete-current-booking"
          isOpen={modalDeleteCurrentBooking}
          withFooter
          isHighlighted
        >
          <SalonModal.Body>
            <IconStatus variant="warning" width="lg">
              <Icon variant="bin" selected width="l1" />
            </IconStatus>
            <div className={CN.modalContent}>
              <div className={CN.modalTitle}>Delete this booking?</div>
              <div className={CN.modalText}>
                This will remove the booking from your diary. To undo this, you would need to contact customer support.
              </div>
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            <div className={CN.modalButtons}>
              <Button variant="outlineForce" onClick={this.props.closeModal}>
                GO BACK
              </Button>
              <Button
                variant="alert"
                onClick={() => {
                  this.onDelete(depositData, clientHasCard, true);
                  this.setState({ modalDeleteCurrentBooking: false });
                }}
                xSpace
              >
                DELETE BOOKING
              </Button>
            </div>
          </SalonModal.Footer>
        </SalonModal>

        {modalRequestDeposit && (
          <div
            onMouseDown={(e) => e.stopPropagation()}
            onMouseMove={(e) => e.stopPropagation()} //  Stop drag
          >
            <DepositRequesModal
              onRequestClose={onRequestClose}
              onDepositRequest={this.onDepositRequest}
              procedure={this.props.procedure}
              appointment={appointment.response}
              clientHasCard={clientHasCard}
              userName={userName}
              salonName={this.props.salonName}
            />
          </div>
        )}
        <SalonModal tag="ProcedureModal__modal--payments" isOpen={modalSetupPaymentAccount} withFooter>
          <SalonModal.Body>
            <div className={CN.modalContent}>
              <div className={CN.modalTitle}>Setup payments account</div>
              <span className={CN.modalText}>
                To request a deposit or card details, you need to setup a Stripe account so Slick knows where to send
                money collected from clients
              </span>
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            <div className={CN.modalButtons}>
              <Button variant="outlineForce" onClick={onRequestClose} xSpace>
                CANCEL
              </Button>
              <Button variant="primaryForce" onClick={this.onRequestPayments} xSpace>
                GO TO PAYMENTS
              </Button>
            </div>
          </SalonModal.Footer>
        </SalonModal>

        {chargeFeeModal && !this.props.noshowChargeErrorInBooking && (
          <ChargeFeeForm
            onRequestClose={onRequestClose}
            appointmentStatuses={this.props.appointmentStatuses}
            totalPrice={total}
            onConfirmCharge={this.onConfirmCharge}
            salonId={this.props.salonId}
            isOpen={
              clientHasCard &&
              (!depositData || !depositData.amount) &&
              errorMessageFromProps !== 'authentication_required'
            }
          />
        )}

        {/* OR !!!  Modals for online deposit banked as no-show */}
        {depositData && depositData.amount && (
          <DepositBankedNoShowModal
            onRequestClose={onRequestClose}
            onConfirmCharge={this.onConfirmCharge}
            depositData={depositData}
            appointmentStatuses={this.props.appointmentStatuses}
            userName={userName}
            clientHasCard={clientHasCard}
            isOpen={chargeFeeModal && !this.props.noshowChargeErrorInBooking}
          />
        )}

        {/* OR !!!  Modals for no deposit no card */}
        {!depositData && !clientHasCard && (
          <DepositBankedNoShowModal
            onRequestClose={onRequestClose}
            onConfirmCharge={() => this.onStatusChange(AP_STATUS.noShow)}
            depositData={depositData}
            appointmentStatuses={this.props.appointmentStatuses}
            userName={userName}
            clientHasCard={clientHasCard}
            isOpen={chargeFeeModal && !this.props.noshowChargeErrorInBooking}
          />
        )}

        {showRebookComponent && (
          <RebookAppointment
            oldAppointment={this.state.oldAppointment}
            from={AP_STATUS.paid === statusFromProps ? REBOOK_TIME.after : REBOOK_TIME.before}
            showRebook={this.showRebook}
            fetchProceduresBySalon={this.props.fetchProceduresBySalon}
            fetchEventsBySalon={this.props.fetchEventsBySalon}
          />
        )}
        {this.state.showSms && (
          <SmsButtonNew
            procedure={this.props.procedure}
            bucketType="appointment"
            smsComposeModalOpen={this.state.showSms}
            showParentSmsPopup={this.showSmsPopup}
          />
        )}
        {this.state.modalNoSmsCredit && (
          <NoSmsCredit
            isModalAction={false}
            history={this.props.history}
            closeNoSmsCreditModal={this.closeNoSmsCreditModal}
            purchaseSmsBundle={this.props.purchaseSmsBundle}
            salonId={this.props.salonId}
            errorMessage={this.props.purchaseError}
            gotoBilling={this.gotoBilling}
            isFetching={this.props.isFetching}
            sms_credits_available={this.props.sms_credits_available}
            permission={this.props.permission}
          />
        )}
        {this.state.modalClientNoPhone && (
          <div className="popup-2-button animated zoomIn" style={{ zIndex: '500' }}>
            <div className="flex-center">
              <div className="modal-content">
                <div className="sms-title client-no-phone-message">
                  <div>
                    * Sorry you can&apos;t send an SMS to this client as they do not have a valid UK mobile number in
                    their profile
                  </div>
                </div>
                <br />
              </div>
            </div>

            <div className="cfix">
              <div className="marketing-button-container">
                <button className="sms-btn-white" onClick={onRequestClose}>
                  Back
                </button>
              </div>
            </div>
          </div>
        )}
        {isBillingRendered && <NoBillingModal isOpen onClose={this.hideNoBilling} />}
      </div>
    );
  }
}

const ProcedureModalIntermediary = ({ feProcedureModalMount, onMount, onUnmount, ...extra }) => {
  useEffect(() => {
    call('ProcedureModalIntermediary.onMount', onMount ?? alwaysNoop);
    feProcedureModalMount({ mounted: true });
    return () => {
      call('ProcedureModalIntermediary.onUnmount', onUnmount ?? alwaysNoop);
      feProcedureModalMount({ mounted: false });
    };
  }, [feProcedureModalMount, onMount, onUnmount]);

  return <ProcedureModal {...extra} />;
};

const ProcedureModalHoc = withRouter(
  connect(
    (state) => ({
      salonId: state.currentSalon.id,
      salonName: state.currentSalon.name,
      noshowChargeSuccess: state.scheduler.noshowChargeSuccess,
      noshowChargeError: state.scheduler.noshowChargeError,
      noshowChargeErrorInBooking: state.booking.noshowChargeErrorInBooking,
      chargeSuccess: state.scheduler.chargeSuccess,
      salonOnlineBooking: state.settings.onlineBooking.settingsData.online_booking,
      ncobTinyUrl: state.settings.onlineBooking.settingsData.ncob_tiny_url,
      appointmentDetails: state.scheduler.appointmentDetails,
      isClientBirthdayToday: state.scheduler.isClientBirthdayToday,
      deposits: state.scheduler.deposits,
      preferenceList: state.scheduler.preferenceList,
      clientViewData: state.settings.balanceSheet.clientViewData,
      no_show_protection: state.currentSalon.no_show_protection,
      ncob_deposit_settings: state.currentSalon.ncob_deposit_settings,
      successful: state.transaction.create.successful,
      appointmentStatuses: state.booking.appointmentStatuses,
      hideDetails: selectHideDetails(state),
      permission: selectEffectiveUserRole(state),
      isReBooking: state.booking.isReBooking,
      requestDepositSuccess: state.scheduler.requestDepositSuccess,
      sms_credits_available: state.clientCommunications.sms_credits_available,
      isFetching: state.clientCommunications.isFetching,
      purchaseError: state.clientCommunications.errorMessage,
      hasBetaAnnualSalon: selectCurrentSalonBetaAnnualSalon(state),
      hasBilling: selectCurrentSalonBilling(state),
    }),
    mapActionsToDispatchToProps({
      // actions from src/scheduler/actions.js
      setCreation,
      setModal,
      pickCurrentStylist,
      createIfAllowed,
      updateNewBookingDate,
      fetchProceduresBySalon,
      fetchEventsBySalon,
      deleteAllAppointments: deleteAllAppointmentsV1,
      updateProcedure,
      reorderStylists,
      saveStylistOrder,
      reorderStylistsThenSave,
      hideInactiveStylists,
      showAllStylist,

      setView,
      setCurrentDay,
      fetchAppointmentDetails,
      fetchClientLabels,
      fetchDeposit,
      savePreference,
      revertProcedureLog,
      deletePreference,
      markAppointmentEdit,
      setBookedByButton,
      setDropTime,
      setDragFrom,
      undoProcedure,
      emptyAppointmentStatuses,
      clearNoshowChargeInfo,
      requestDeposit,
      clearRequestDepositSuccess,

      beChargeCardOnFile: beChargeCardOnFileV1,
      clearChargeError,
      fetchClientDepositDetails,
      getSalonOnlineSettings,
      getPreferenceList,
      purchaseSmsBundle,
      rebook: xeRebook,
      trackEvent,
      feProcedureModalMount,
    }),
  )(ProcedureModalIntermediary),
);

export default ProcedureModalHoc;
